(function() {

    angular
        .module('ngmvac')
        .filter('toArray', toArray);

    function toArray() {
        return function(seconds) {
            var h = parseInt(seconds / 3600);
            var m = parseInt((seconds - (h * 3600)) / 60);
            var s = parseInt(seconds - ((h*3600)+(m*60)));

            return  ((m < 10) ? '0' + m : m) +
                    ':' +
                    ((s < 10) ? '0' + s : s);
        }
    }

})();
